import { useCallback } from 'react';

import { useAppDispatch } from 'js/store/hooks';
import { showImageGenerationView } from 'js/actionCreators/ImageDrawerActions';
import { ChangeStepTrigger } from 'js/actionCreators/aiFeaturesActions';

const useOpenImageGeneration = () => {
  const dispatch = useAppDispatch();

  return useCallback(
    (trigger: ChangeStepTrigger, prompt?: string) => {
      dispatch(showImageGenerationView(trigger, prompt));
    },
    [dispatch]
  );
};

export default useOpenImageGeneration;
